import ArticleIcon from '@mui/icons-material/Article';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import InfoIcon from '@mui/icons-material/Info';
import LockIcon from '@mui/icons-material/Lock';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import SecurityIcon from '@mui/icons-material/Security';
import SendIcon from '@mui/icons-material/Send';
import { Box, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function Footer() {
    const navigate = useNavigate();

    const footerLinkStyle = {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        color: 'var(--text-secondary)',
        textDecoration: 'none',
        fontSize: '0.875rem',
        cursor: 'pointer',
        transition: 'color 0.2s ease',
        '&:hover': {
            color: 'var(--text-primary)'
        }
    };

    return (
        <Box
            component="footer"
            sx={{
                marginTop: 'auto',
                padding: '24px 20px',
                borderTop: '1px solid var(--border-color)',
                backgroundColor: 'var(--background-color)'
            }}
        >
            <Box
                sx={{
                    maxWidth: '1200px',
                    margin: '0 auto',
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '40px',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >
                <Link
                    onClick={() => navigate('/about')}
                    sx={footerLinkStyle}
                >
                    <InfoIcon fontSize="small" />
                    About Us
                </Link>
                <Link
                    onClick={() => navigate('/pricing')}
                    sx={footerLinkStyle}
                >
                    <AttachMoneyIcon fontSize="small" />
                    Pricing
                </Link>
                <Link
                    onClick={() => navigate('/pricing')}
                    sx={footerLinkStyle}
                >
                    <SecurityIcon fontSize="small" />
                    Security
                </Link>
                <Link
                    onClick={() => navigate('/terms')}
                    sx={footerLinkStyle}
                >
                    <ArticleIcon fontSize="small" />
                    Terms of Service
                </Link>
                {/* Static HTML anchor for Google Auth Console compliance - must be in static HTML */}
                <a
                    href="/privacy"
                    className="footer-static-link"
                >
                    <LockIcon fontSize="small" />
                    Privacy Policy
                </a>
                <Link
                    onClick={() => navigate('/contact')}
                    sx={footerLinkStyle}
                >
                    <SendIcon fontSize="small" />
                    Contact Us
                </Link>
                <Link
                    onClick={() => navigate('/press')}
                    sx={footerLinkStyle}
                >
                    <NewspaperIcon fontSize="small" />
                    Press
                </Link>
                <Link
                    onClick={() => navigate('/chdpp')}
                    sx={footerLinkStyle}
                >
                    <MedicalServicesIcon fontSize="small" />
                    Consumer Health Data Privacy Policy
                </Link>
            </Box>
        </Box>
    );
}

